(() => {
  'use strict';
  const configNode = document.getElementById('bf-walk-config');
  if (!configNode) return;
  const cfg = JSON.parse(configNode.textContent), t = cfg.text;
  const root = window.Shopify?.routes?.root || '/';
  const nativeFetch = window.bfWalkNativeFetch || window.fetch.bind(window);
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:cfg.currency}).format(cents / 100);
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const uid = () => crypto.randomUUID();
  const colors = ['Red','Wine','Magenta','Pink','Orange','Yellow','Fluorescent Yellow','Teal','Seafoam Green','Dusty Turquiose','Olive','Deep Navy','Royal Blue','Cerulean Blue','Sky Blue','Periwinkle Blue','Purple','Lilac','Caramel','White','Black'];
  const normalize = s => s === 'Dusty Turquoise' ? 'Dusty Turquiose' : s;
  const hardware = ['Silver','Matte Black','Gold'];
  const extras = [53489931682103,53489940726071];
  const products = cfg.products;
  const available = p => (p?.variants || []).filter(v => v.available);
  const variant = (p,id) => p?.variants?.find(v => String(v.id) === String(id));
  const variantColor = (p,color) => available(p).find(v => v.option1 === color);
  const fixed = cfg.designs;
  let busy = false, uncertain = false;
  async function json(url, options) {
    const response = await nativeFetch(url, {credentials:'same-origin', cache:'no-store', ...options});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || t.failed);
    return data;
  }
  const cart = () => json(`${root}cart.js`);
  const post = (path,data) => json(`${root}${path}`, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(data)});
  function context(handle, props = {}, title = '') {
    const base = fixed[handle] || {};
    return {...base,handle,title:title || base.title || cfg.product?.title || '',
      primary:normalize(props['Primary Color'] || base.primary || ''),
      keeper:normalize(props['Loop Color'] || base.keeper || ''),
      hardware:props['Hardware Color'] || base.hardware || '',
      style:props.Style || base.style || ''};
  }
  function matches(c) {
    if (c.ropes?.length) return c.ropes;
    if (/cactus|western|southwest/i.test(`${c.style} ${c.primary} ${c.title}`)) return ['Caramel','Cream'];
    if (/floral/i.test(`${c.title} ${c.handle}`)) return ['Cream','Fir'];
    return [...new Set([c.primary,c.keeper].filter(x => ['Wine','Caramel'].includes(x)))];
  }
  function signature(c) {return JSON.stringify([c.primary,c.keeper,c.hardware,c.style,c.handle]);}
  function photo(p,v) {
    const image = v?.featured_image?.src || cfg.images?.[String(v?.id)] || (p === products.floral ? p?.featured_image : '');
    return image ? `<img src="${esc(image)}${image.includes('?')?'&':'?'}width=240" width="88" height="88" loading="lazy" alt="${esc((v?.title || '')+' '+p.title)}">` : '';
  }
  function select(label,key,options,value='',placeholder=t.choose) {
    return `<label>${esc(label)}<select data-field="${key}"><option value="">${esc(placeholder)}</option>${options.map(o => {const v=typeof o==='string'?o:o.value,l=typeof o==='string'?o:o.label; return `<option value="${esc(v)}" ${String(value)===String(v)?'selected':''}>${esc(l)}</option>`;}).join('')}</select></label>`;
  }
  class Panel {
    constructor(mount,c,{mode='product',group='',existing=[]}={}) {
      this.el=mount; this.c=c; this.mode=mode; this.group=group; this.existing=existing;
      this.state={rope:'',bio:false,bag:'',style:'one',primary:c.primary,accent:c.keeper,hardware:c.hardware,length:'',width:''};
      this.review=false; this.sig=signature(c); this.el.className='bf-walk';
      this.el.addEventListener('change',e=>{e.stopPropagation();this.change(e);});
      this.el.addEventListener('click',e=>this.click(e));
      this.render();
    }
    selected(){return !!(this.state.rope||this.state.bio||this.state.bag);}
    update(c){
      if(signature(c)===this.sig) {this.c=c;this.total();return;}
      if(this.selected()) this.review=true;
      else Object.assign(this.state,{primary:c.primary,accent:c.keeper,hardware:c.hardware});
      this.c=c;this.sig=signature(c);this.render();
    }
    change(e){
      const k=e.target.dataset.field;if(!k)return;
      const s=this.state;
      if(k==='bio') s.bio=e.target.checked; else s[k]=e.target.value;
      this.render();
      this.el.querySelector(`[data-field="${k}"]`)?.focus({preventScroll:true});
    }
    async click(e){
      const action=e.target.closest('[data-action]')?.dataset.action;
      if(action==='keep'){this.review=false;this.render();}
      if(action==='rematch'){
        Object.assign(this.state,{primary:this.c.primary,accent:this.c.keeper,hardware:this.c.hardware});
        if(this.state.rope && !matches(this.c).includes(variant(products.rope,this.state.rope)?.option1)) this.state.rope='';
        this.review=false;this.render();
      }
      if(action==='dismiss'){try{sessionStorage.setItem(`bf-walk-dismiss-${this.group}`,'1');}catch{}this.el.remove();}
      if(action==='add'){
        const button=e.target.closest('button');button.disabled=true;
        try{const items=await this.items();if(!items.length)throw new Error(t.select_one);await transact(items);location.reload();}
        catch(err){this.error(err.message);button.disabled=false;}
      }
    }
    render(){
      const s=this.state,c=this.c, floral=!!c.floral;
      const recommended=matches(c).map(color=>variantColor(products.rope,color)).filter(Boolean);
      const keep=variant(products.rope,s.rope);
      if(keep&&!recommended.some(v=>v.id===keep.id))recommended.push(keep);
      const hasLeash=this.existing.includes('leash'),hasBag=this.existing.includes('bag');
      const rope=variant(products.rope,s.rope), bag=variant(products.bag,s.bag);
      const ropeOptions=recommended.map(v=>({value:v.id,label:`${v.option1} · ${money(v.price)}${v.available?'':` · ${t.sold_out}`}`}));
      this.el.innerHTML=`<div class="bf-walk-heading"><h3>${esc(t.title)}</h3>${this.mode==='cart'?`<button type="button" data-action="dismiss" class="bf-walk-link">${esc(t.dismiss)}</button>`:''}</div><p class="bf-walk-intro">${esc(this.mode==='cart'?`${t.for_collar} ${c.title}`:t.optional)}</p>
      ${this.review?`<div class="bf-walk-review" role="status"><p>${esc(t.review)}</p><button type="button" data-action="rematch">${esc(t.rematch)}</button><button type="button" data-action="keep">${esc(t.keep)}</button></div>`:''}
      ${!hasLeash&&recommended.length?`<div class="bf-walk-choice"><div class="bf-walk-product">${photo(products.rope,rope||recommended[0])}<div><strong>${esc(t.rope)}</strong><p>${esc(t.rope_note)}</p></div></div>${select(t.rope_color,'rope',ropeOptions,s.rope,t.no_rope)}<p>${esc(c.primary===rope?.option1?t.strap_match:c.keeper===rope?.option1?t.keeper_match:t.coordinated)}</p></div>`:''}
      ${!hasLeash&&available(floral?products.floral:products.bio).length?`<div class="bf-walk-choice"><label class="bf-walk-check"><input type="checkbox" data-field="bio" ${s.bio?'checked':''}><span><strong>${esc(floral?t.floral:t.biothane)}</strong> · ${money((floral?products.floral:products.bio)?.price || 0)}</span></label>${s.bio?`<div class="bf-walk-options">${floral?`${photo(products.floral,available(products.floral).find(v=>v.options.some(o=>o.startsWith(s.width)))||available(products.floral)[0])}<p>${esc(t.floral_note)}</p>`:`${select(t.construction,'style',[{value:'one',label:t.one},{value:'two',label:t.two}],s.style)}<p>${esc(t.color_rule)}</p>${select(t.body,'primary',colors,s.primary)}${s.style==='two'?select(t.handle_base,'accent',colors,s.accent):`<p>${esc(t.one_note)}</p>`}${select(t.hardware,'hardware',hardware,s.hardware)}${select(t.length,'length',[{value:'4 Foot',label:t.four},{value:'5 Foot',label:t.five},{value:'6 Foot',label:t.six}],s.length)}`}${select(t.width,'width',['3/4"','1"'],s.width)}${!floral&&s.style==='two'&&s.primary&&s.primary===s.accent?`<p>${esc(t.same_color)}</p>`:''}</div>`:''}</div>`:''}
      ${!hasBag&&(s.rope||s.bag||hasLeash)?`<div class="bf-walk-choice"><div class="bf-walk-product">${photo(products.bag,bag||variantColor(products.bag,rope?.option1)||available(products.bag)[0])}<div><strong>${esc(t.bag)}</strong><p>${esc(t.bag_note)}</p></div></div>${select(t.bag_color,'bag',available(products.bag).sort((a,b)=>Number(b.option1===rope?.option1)-Number(a.option1===rope?.option1)).map(v=>({value:v.id,label:`${v.option1} · ${money(v.price)}`})),s.bag,t.no_bag)}</div>`:''}
      <p class="bf-walk-total" aria-live="polite"></p><p class="bf-walk-error" role="alert" hidden></p>${this.mode==='cart'?`<button type="button" data-action="add" class="button">${esc(t.add_selected)}</button>`:''}<p class="bf-walk-footnote">${esc(t.material_note)}</p>`;
      this.total();
      const form=this.el.closest('form');
      form?.querySelectorAll('.shopify-payment-button').forEach(el=>{el.hidden=this.selected();});
    }
    total(){
      const s=this.state; let sum=(variant(products.rope,s.rope)?.price||0)+(variant(products.bag,s.bag)?.price||0)+(s.bio?(this.c.floral?products.floral:products.bio)?.price||0:0);
      const price=this.c.price;
      const node=this.el.querySelector('.bf-walk-total');
      const shadow=this.el.getRootNode();
      if(shadow.host?.tagName==='BF-BELT-CUSTOMIZER'){
        const info=shadow.querySelector('.mbar-info'),original=info?.querySelector('.price');
        if(info&&original){let combined=info.querySelector('.bf-walk-mobile-total');if(!combined){combined=document.createElement('span');combined.className='bf-walk-mobile-total';info.prepend(combined);}
          original.hidden=!!sum;combined.hidden=!sum;combined.textContent=Number.isFinite(price)?`${money(price+sum)} ${t.total_short}`:`${t.accessories} ${money(sum)}`;
        }
      }
      if(node)node.textContent=sum?(Number.isFinite(price)?`${t.total} ${money(price+sum)} · ${t.accessories} ${money(sum)}`:`${t.accessories} ${money(sum)}`):t.collar_only;
    }
    error(message){const el=this.el.querySelector('.bf-walk-error');el.textContent=message;el.hidden=false;el.scrollIntoView({block:'nearest'});}
    async items(){
      if(this.review){this.error(t.review);throw new Error(t.review);}
      const s=this.state, result=[],group=this.group||uid();this.group=group;
      const props={_bf_walk_for:group,'For Collar':this.c.title||this.c.style||t.custom_collar};
      if(s.rope) result.push({id:Number(s.rope),quantity:1,properties:{...props,_bf_walk_kind:'leash'}});
      if(s.bio){
        let p,v,custom={};
        if(this.c.floral){p=products.floral;v=available(p).find(v=>v.options.some(o=>o.startsWith(s.width)));if(!s.width)v=null;}
        else{
          p=products.bio;v=available(p).find(v=>v.options.includes(s.width)&&v.options.includes(s.length));
          if(!['one','two'].includes(s.style))throw new Error(t.complete_leash);
          const accent=s.style==='one'?s.primary:s.accent;
          if(!colors.includes(s.primary)||!colors.includes(accent)||!hardware.includes(s.hardware)||!v)throw new Error(t.complete_leash);
          custom={'Leash Style':s.style==='one'?t.one:t.two,'Primary Color':s.primary,'Accent Color':accent,'Handle and Base Color':accent,'Hardware Color':s.hardware};
        }
        if(!v)throw new Error(t.complete_leash);
        result.push({id:v.id,quantity:1,properties:{...props,...custom,_bf_walk_kind:'leash'}});
      }
      if(s.bag)result.push({id:Number(s.bag),quantity:1,properties:{...props,_bf_walk_kind:'bag'}});
      return result;
    }
  }
  async function transact(items) {
    if(busy)throw new Error(t.busy);
    if(uncertain)throw new Error(t.check_cart);
    busy=true;
    const tx=uid();
    items=items.map(i=>({...i,properties:{...i.properties,_bf_walk_tx:tx}}));
    try{
      const ids=new Set(items.map(i=>i.id));
      for(const p of Object.values(products)){
        if(!p?.variants?.some(v=>ids.has(v.id)))continue;
        const fresh=await json(`${root}products/${p.handle}.js`);
        for(const i of items.filter(i=>p.variants.some(v=>v.id===i.id))){const old=variant(p,i.id),now=variant(fresh,i.id);if(!now?.available)throw new Error(t.unavailable);if(now.price!==old.price)throw new Error(t.price_changed);}
      }
      return await post('cart/add.js',{items});
    }catch(error){
      try{const current=await cart(), own=current.items.filter(i=>i.properties?._bf_walk_tx===tx);if(own.length)await post('cart/update.js',{updates:Object.fromEntries(own.map(i=>[i.key,0]))});}
      catch{uncertain=true;throw new Error(t.check_cart);}
      throw error;
    }finally{busy=false;}
  }
  function customContext(host){
    const summary=host.shadowRoot?.querySelector('.summary');if(!summary)return null;
    const fields={};summary.querySelectorAll('dl > div').forEach(row=>{fields[row.querySelector('dt')?.textContent.trim()]=row.querySelector('dd')?.textContent.trim();});
    const material=fields.Material?.split(' + ')[0]||'';
    const c=context('1-color-biothane-collar',{'Primary Color':material,'Loop Color':fields.Keeper,'Hardware Color':fields.Hardware,Style:fields.Style},fields.Style);
    const price=summary.querySelector('.buy .price')?.textContent.replace(/[^\d.]/g,'');
    if(price)c.price=Math.round(Number(price)*100);
    return c;
  }
  let customPanel;
  function mountCustomizer(){
    const host=document.querySelector('bf-belt-customizer'),shadow=host?.shadowRoot,summary=shadow?.querySelector('.summary');
    if(!summary)return false;
    const link=document.createElement('link');link.rel='stylesheet';link.href=cfg.css;shadow.append(link);
    const mount=document.createElement('div');summary.querySelector('.buy').before(mount);
    customPanel=new Panel(mount,customContext(host));
    let pending=false;
    new MutationObserver(mutations=>{
      if(mutations.every(m=>mount.contains(m.target))||pending)return;
      pending=true;queueMicrotask(()=>{pending=false;const c=customContext(host);if(c)customPanel.update(c);});
    }).observe(summary,{subtree:true,childList:true,characterData:true});
    return true;
  }
  function mountProduct(){
    if(!cfg.product||cfg.product.handle==='1-color-biothane-collar')return;
    const eligible=!!fixed[cfg.product.handle] || /biothane/i.test(cfg.product.title)&&/collar/i.test(cfg.product.title);
    if(!eligible)return;
    const gallery=document.querySelector('.bf-gallery-purchase form'),form=gallery||document.querySelector('product-form form[data-type="add-to-cart-form"]');
    if(!form)return;
    const button=form.querySelector('[type="submit"]');if(!button)return;
    const mount=document.createElement('div');button.before(mount);
    const read=()=>{
      const data=new FormData(form),props={};for(const [k,v] of data){const match=k.match(/^properties\[(.+)\]$/);if(match)props[match[1]]=v;}
      const c=context(cfg.product.handle,props,cfg.product.title);const price=variant(cfg.product,data.get('id'))?.price;c.price=Number.isFinite(price)?price*Number(data.get('quantity')||1):undefined;return c;
    };
    const panel=new Panel(mount,read());form.bfWalkPanel=panel;
    document.addEventListener('change',e=>{if(e.target.form===form&&!mount.contains(e.target))panel.update(read());});
    new MutationObserver(()=>panel.update(read())).observe(form,{subtree:true,attributes:true,attributeFilter:['value']});
    if(gallery)form.addEventListener('submit',async e=>{
      e.preventDefault();if(!form.reportValidity())return;button.disabled=true;
      try{const data=new FormData(form),group=uid();panel.group=group;
        const items=[{id:Number(data.get('id')),quantity:Number(data.get('quantity')||1),properties:{_bf_walk_group:group}} ,...await panel.items()];
        await transact(items);location.href=`${root}cart`;
      }catch(err){panel.error(err.message);button.disabled=false;}
    });
  }
  async function addCustomizer(items,host){
    const first=items.find(i=>!extras.includes(i.id));
    const group=uid();
    items=items.map(i=>({...i,properties:{...i.properties,_design_id:group,...(!extras.includes(i.id)?{_bf_walk_group:group}:{})}}));
    if(customPanel){
      customPanel.group=group;
      const live=context('1-color-biothane-collar',first.properties,customPanel.c.title);
      customPanel.update({...live,price:customPanel.c.price});
      items.push(...await customPanel.items());
    }
    return transact(items);
  }
  async function addForm(form,data){
    const panel=form.bfWalkPanel;if(!panel)return null;
    const group=uid(),properties={_bf_walk_group:group};panel.group=group;
    for(const [k,v] of data){const match=k.match(/^properties\[(.+)\]$/);if(match)properties[match[1]]=v;}
    const items=[{id:Number(data.get('id')),quantity:Number(data.get('quantity')||1),properties},...await panel.items()];
    try{const added=await transact(items),sections=data.get('sections');
      if(sections){try{added.sections=await json(`${root}?sections=${encodeURIComponent(sections)}`);}catch{location.href=`${root}cart`;return added;}}
      added.id=added.items?.[0]?.id;return added;
    }catch(err){panel.error(err.message);return {status:422,description:err.message};}
  }
  async function changeCart(row,quantity,sections){
    if(busy)throw new Error(t.busy);busy=true;
    try{
      const current=await cart(),item=current.items.find(i=>i.key===row?.dataset.bfKey);
      if(!item)throw new Error(t.cart_changed);
      const group=item.properties?._design_id;
      const parent=group&&current.items.find(i=>i.properties?._design_id===group&&!extras.includes(i.variant_id));
      if(extras.includes(item.variant_id)&&parent)throw new Error(t.attached);
      const updates={[item.key]:quantity};
      if(group&&!extras.includes(item.variant_id))current.items.filter(i=>i.properties?._design_id===group&&extras.includes(i.variant_id)).forEach(i=>updates[i.key]=quantity);
      const result=Object.keys(updates).length>1
        ? await post('cart/update.js',{updates,sections,sections_url:location.pathname})
        : await post('cart/change.js',{id:item.key,quantity,sections,sections_url:location.pathname});
      return {text:async()=>JSON.stringify(result)};
    }finally{busy=false;}
  }
  let cartGeneration=0;
  async function mountCart(){
    const containers=[...document.querySelectorAll('[data-bf-walk-cart]')];if(!containers.length)return;
    const generation=++cartGeneration;
    try{
      const current=await cart();if(generation!==cartGeneration)return;
      document.querySelectorAll('[data-bf-key]').forEach(row=>{
        const item=current.items.find(i=>i.key===row.dataset.bfKey),group=item?.properties?._design_id;
        if(!item||!extras.includes(item.variant_id)||!group)return;
        if(!current.items.some(i=>i.properties?._design_id===group&&!extras.includes(i.variant_id)))return;
        row.querySelectorAll('quantity-input,cart-remove-button').forEach(el=>el.hidden=true);
        if(!row.querySelector('.bf-attached-note')){const note=document.createElement('p');note.className='bf-attached-note';note.textContent=`${t.attached} · ${item.quantity}`;row.querySelector('.cart-item__quantity')?.append(note);}
      });
      for(const container of containers){
        if(container.dataset.rendered===JSON.stringify(current.items.map(i=>[i.key,i.quantity])))continue;
        container.dataset.rendered=JSON.stringify(current.items.map(i=>[i.key,i.quantity]));container.replaceChildren();
        for(const item of current.items){
          if(!/biothane/i.test(item.product_title)||!/collar/i.test(item.product_title))continue;
          const handle=item.handle||item.url?.split('/products/')[1]?.split('?')[0],c=context(handle,item.properties,item.product_title),group=item.properties?._bf_walk_group||item.properties?._design_id||item.key;
          try{if(sessionStorage.getItem(`bf-walk-dismiss-${group}`))continue;}catch{}
          const paired=current.items.filter(i=>i.properties?._bf_walk_for===group),existing=paired.map(i=>i.properties._bf_walk_kind);
          if(existing.includes('leash')&&existing.includes('bag'))continue;
          const mount=document.createElement('div');container.append(mount);new Panel(mount,c,{mode:'cart',group,existing});break;
        }
      }
    }catch{}
  }
  window.bfWalk={addCustomizer,addForm,changeCart,matches,context};
  mountProduct();
  if(!mountCustomizer()){
    const host=document.querySelector('bf-belt-customizer');
    if(host)customElements.whenDefined('bf-belt-customizer').then(()=>requestAnimationFrame(()=>{
      if(mountCustomizer())return;const observer=new MutationObserver(()=>{if(mountCustomizer())observer.disconnect();});if(host.shadowRoot)observer.observe(host.shadowRoot,{childList:true,subtree:true});
    }));
  }
  mountCart();
  let scheduled=false;
  new MutationObserver(mutations=>{
    if(!mutations.some(m=>[...m.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('[data-bf-walk-cart],.cart-item,cart-drawer-items')||n.querySelector?.('[data-bf-walk-cart],.cart-item')))))return;
    if(scheduled)return;scheduled=true;setTimeout(()=>{scheduled=false;mountCart();},0);
  }).observe(document.body,{childList:true,subtree:true});
})();
